export enum EntitlementType {
  PREMIUM_BUY = 'PREMIUM_BUY',
  PREMIUM_RENT = 'PREMIUM_RENT',
  DOCUMENTS_PLUS_BUY = 'DOCUMENTS_PLUS_BUY',
  DOCUMENTS_PLUS_RENT = 'DOCUMENTS_PLUS_RENT',
  SCHUFA_BONITAETSCHECK = 'SCHUFA_BONITAETSCHECK',
  APPLICATION_PACKAGE_RENT = 'APPLICATION_PACKAGE_RENT',
  DEPOSIT_SERVICE = 'DEPOSIT_SERVICE',
  UTILITY_BILL_CHECK = 'UTILITY_BILL_CHECK',
  STORAGE_SERVICE = 'STORAGE_SERVICE',
  RELOCATION_BOX = 'RELOCATION_BOX',
  KEY_AND_LEGAL_SERVICE = 'KEY_AND_LEGAL_SERVICE',
  TENANT_PROTECTION_SERVICE = 'TENANT_PROTECTION_SERVICE',
  VIEWING_CALENDAR = 'VIEWING_CALENDAR',
  IS24_SOLVENCY_CHECK = 'IS24_SOLVENCY_CHECK',
  ARAG_WP_PACKAGE_S = 'ARAG_WP_PACKAGE_S',
  ARAG_WP_PACKAGE_M = 'ARAG_WP_PACKAGE_M',
  ARAG_WP_PACKAGE_L = 'ARAG_WP_PACKAGE_L',
}

export const Entitlement = [
  EntitlementType.PREMIUM_BUY,
  EntitlementType.PREMIUM_RENT,
  EntitlementType.DOCUMENTS_PLUS_BUY,
  EntitlementType.DOCUMENTS_PLUS_RENT,
  EntitlementType.SCHUFA_BONITAETSCHECK,
  EntitlementType.APPLICATION_PACKAGE_RENT,
  EntitlementType.DEPOSIT_SERVICE,
  EntitlementType.UTILITY_BILL_CHECK,
  EntitlementType.STORAGE_SERVICE,
  EntitlementType.RELOCATION_BOX,
  EntitlementType.KEY_AND_LEGAL_SERVICE,
  EntitlementType.TENANT_PROTECTION_SERVICE,
  EntitlementType.VIEWING_CALENDAR,
  EntitlementType.IS24_SOLVENCY_CHECK,
  EntitlementType.ARAG_WP_PACKAGE_S,
  EntitlementType.ARAG_WP_PACKAGE_M,
  EntitlementType.ARAG_WP_PACKAGE_L,
];

export type Entitlement = {
  entitlementStatus: string;
  externalId: string;
  serviceStartDate: string;
  serviceType: EntitlementType;
  ssoId: string;
  eventTimestamp: number;
};
